import { render } from "./InputTypeTel.vue?vue&type=template&id=7a4da2a1"
import script from "./InputTypeTel.vue?vue&type=script&lang=js"
export * from "./InputTypeTel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__